import React, { useEffect, useState } from "react";
import MUIDataTable from "mui-datatables";
import {
  Button,
  IconButton,
  Tooltip,
  DialogContent,
  Dialog,
  DialogActions,
  TextField,
} from "@mui/material";
import { toast } from "react-toastify";
import moment from "moment";
import { Close } from "@mui/icons-material";
import Axios from "../axios";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import BlockOutlinedIcon from "@mui/icons-material/BlockOutlined";
import { CSVLink, CSVDownload } from "react-csv";
import DownloadIcon from "@mui/icons-material/Download";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import "react-quill/dist/quill.snow.css";
import { Helmet } from "react-helmet";
import { useAuth } from "../auth/authContext";
import { useLocation } from "react-router-dom";
import { useClientReactQuill } from "../utils/reactQuillLoader";
const FAQManagement = () => {
  const ReactQuill = useClientReactQuill();
  const { navData } = useAuth();
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const [name, setName] = useState();
  const [answer, setAnswer] = useState();
  const [category, setCatagory] = useState();
  const [allFAQ, setAllFAQ] = useState();
  const [id, setId] = useState();
  const [opendel, setOpenDel] = useState(false);
  const [type, setType] = useState();
  const [page, setPage] = useState(0);
  const [count, setCount] = useState();
  const [search, setSearch] = useState("");
  const [status, setStatus] = useState(true);
  const [write, setWrite] = useState(false);
  //data for the CSV file
  const [downloadData, setDownloadData] = useState([]);
  //header for the CSv file
  const headers = [
    { label: "Faq Title", key: "question" },
    { label: "Faq Answer", key: "answer" },
    { label: "Created Date", key: "createdAt" },
    { label: "Display Status", key: "userStatus" },
  ];
  useEffect(() => {
    fetchAllFaq(0, "");
    handleDownloadProcess();
  }, []);
  //this will do set the write State based on the navDAta from the useAuth
  useEffect(() => {
    const currentPath = location.pathname;
    const matchingNavItem = navData.find((item) => item.link === currentPath);
    if (matchingNavItem) {
      setWrite(matchingNavItem.write);
    } else {
      setWrite(false);
    }
  }, [location.pathname, navData]);
  const fetchAllFaq = (page, search) => {
    let data = {
      page: page,
      searchChar: search,
    };
    Axios.post(process.env.REACT_APP_BACKEND + "get-all-faq", data)
      .then((resp) => {
        setAllFAQ(resp?.data?.data?.docs);
        setCount(resp?.data?.data?.totalDocs);
      })
      .catch((err) => {
        toast.error(
          err && err.response && err.response.data && err.response.data.message
        );
      });
  };
  const stripHtml = (html) => {
    return html.replace(/<[^>]+>/g, ""); // Removes all HTML tags
  };
  //API CSV Data
  const handleDownloadProcess = () => {
    Axios.post(process.env.REACT_APP_BACKEND + "get-faq-csv-data")
      .then((resp) => {
        const processedData = resp?.data?.data.map((item) => ({
          ...item,
          answer: stripHtml(item.answer), // Strip HTML before exporting
        }));
        setDownloadData(processedData);
      })
      .catch((err) => {
        toast.error(
          err && err.response && err.response.data && err.response.data.message
        );
      });
  };
  //-------------option for the mui table----------------------------
  const options = {
    responsive: "standard",
    selectableRows: "none",
    filter: false,
    viewColumns: false,
    rowsPerPageOptions: [],
    serverSide: true,
    count: count,
    download: false,
    page,
    onTableChange: (action, tableState) => {
      if (action === "changePage") {
        fetchAllFaq(tableState.page, search);
        setPage(tableState.page);
      }
    },
    onSearchChange: (searchText) => {
      fetchAllFaq(page, searchText);
      setSearch(searchText);
    },
    customToolbar: () => (
      <>
        <Tooltip title="Download">
          <IconButton>
            <CSVLink data={downloadData} headers={headers} filename={"Faq.csv"}>
              <DownloadIcon />
            </CSVLink>
          </IconButton>
        </Tooltip>
      </>
    ),
  };

  const removeHtmlTags = (str) => {
    const doc = new DOMParser().parseFromString(str, "text/html");
    return doc.body.textContent || "";
  };
  const columns = [
    {
      name: "question",
      label: "FAQ Title",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "answer",
      label: "FAQ Answer",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex) => {
          const cleanAnswer = removeHtmlTags(allFAQ[dataIndex]?.answer || ""); // Remove HTML tags
          return (
            <div className="parent-container">
              <p className="clamp-3-lines">{cleanAnswer}</p>
            </div>
          );
        },
        setCellProps: () => ({
          style: { width: "150px", whiteSpace: "normal" }, // Set width directly here
        }),
      },
    },
    {
      name: "createdAt",
      label: "Created Date",

      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex) => {
          return (
            <div>
              {moment(allFAQ[dataIndex].publishedAt).format("YYYY-MM-DD")}
            </div>
          );
        },
      },
    },

    {
      name: "display",
      label: "Display Status",
      options: {
        filter: false,
        sort: false,

        customBodyRenderLite: (dataIndex) => {
          const isPublished = allFAQ[dataIndex]?.blockedStatus;

          return (
            <p
              className={`capsule ${isPublished ? "published" : "unpublished"}`}
            >
              {isPublished ? "Published" : "Unpublished"}
            </p>
          );
        },
      },
    },
    {
      name: "options",
      label: "Action",

      options: {
        filter: false,
        sort: false,

        customBodyRenderLite: (dataIndex) => {
          return (
            <>
              <Tooltip title="View FAQ">
                <IconButton
                  aria-label="View FAQ"
                  onClick={() => handleOpen(allFAQ[dataIndex], "view")}
                >
                  <RemoveRedEyeOutlinedIcon className="icon-size" />
                </IconButton>
              </Tooltip>
              {write ? (
                <>
                  <Tooltip title="Edit FAQ">
                    <IconButton
                      aria-label="Edit FAQ"
                      onClick={() => handleOpen(allFAQ[dataIndex], "edit")}
                    >
                      <EditOutlinedIcon className="icon-size" />
                    </IconButton>
                  </Tooltip>
                  <Tooltip
                    title={
                      allFAQ[dataIndex]?.blockedStatus
                        ? "Unpublished"
                        : "Published"
                    }
                  >
                    <IconButton
                      aria-label="Block FAQ"
                      onClick={() =>
                        handleOpen(
                          allFAQ[dataIndex]._id,
                          "block",
                          allFAQ[dataIndex]?.blockedStatus
                        )
                      }
                    >
                      <BlockOutlinedIcon className="red-color fs-16 icon-size" />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Delete">
                    <IconButton
                      aria-label="Delete FAQ"
                      onClick={() =>
                        handleOpen(allFAQ[dataIndex]._id, "delete")
                      }
                    >
                      <DeleteOutlineOutlinedIcon className="red-color fs-16 icon-size" />
                    </IconButton>
                  </Tooltip>
                </>
              ) : (
                <></>
              )}
            </>
          );
        },
      },
    },
  ];

  // Function for dialog open close
  const handleOpen = (userid, type, status) => {
    if (type === "delete") {
      setId(userid);
      setOpenDel(true);
    } else if (type === "block") {
      setId(userid);
      setOpenDel(true);
      setType("block");
      setStatus(status);
    } else if (type === "edit") {
      setName(userid?.question);
      setAnswer(userid?.answer);
      setCatagory(userid?.category);
      setId(userid._id);
      setType("edit");
      setOpen(true);
    } else if (type === "view") {
      setName(userid?.question);
      setAnswer(userid?.answer);
      setCatagory(userid?.category);
      setId(userid._id);
      setType("view");
      setOpen(true);
    } else {
      setOpen(true);
    }
  };
  const handleClose = () => {
    setOpen(false);
    setOpenDel(false);
    setType("");
    setName("");
    setAnswer("");
    setId("");
    setStatus(true);
    setCatagory("");
  };

  // Function to set the data in the appropriate state
  const handleChange = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    if (name === "name") {
      setName(value);
    } else if (name === "answer") {
      setAnswer(value);
    } else if (name === "category") {
      setCatagory(value);
    }
  };
  // Function top create a new user
  const handleSubmit = () => {
    if (name === "" || name === null || name === undefined) {
      toast.error("Title is required");
      return;
    }
    if (answer === "" || answer === null || answer === undefined) {
      toast.error("Description  is required");
      return;
    }
    let api;
    let data;
    if (type === "edit") {
      api = "update-faq";
      data = {
        question: name,
        answer: answer,
        category: category,
        id: id,
      };
    } else {
      api = "create-faq";
      data = {
        question: name,
        answer: answer,
        category: category,
      };
    }

    Axios.post(process.env.REACT_APP_BACKEND + api, data)
      .then((resp) => {
        setAllFAQ(resp?.data?.data?.docs);
        setCount(resp?.data?.data?.totalDocs);
        toast.success(resp && resp.data && resp.data.message);
        handleClose();
      })
      .catch((err) => {
        toast.error(
          err && err.response && err.response.data && err.response.data.message
        );
      });
  };
  // Function to delete the user
  const handleDelete = () => {
    let api;
    if (type === "block") {
      api = "update-faq-status";
    } else {
      api = "delete-faq";
    }
    Axios.post(process.env.REACT_APP_BACKEND + api, {
      id: id,
    })
      .then((resp) => {
        setAllFAQ(resp?.data?.data?.docs);
        setCount(resp?.data?.data?.totalDocs);
        toast.success(resp && resp.data && resp.data.message);
        handleClose();
      })
      .catch((err) => {
        toast.error(
          err && err.response && err.response.data && err.response.data.message
        );
      });
  };

  return (
    <>
      <Helmet>
        <title>Sevenly-FAQ</title>
        <meta name="FAQ" content="FAQ for Home Page" />
      </Helmet>
      <h1 className="mb--12 sevenly-cursor"> — </h1>
      <div className="d-flex justify-content-between mb-2">
        <h2>FAQ Management</h2>
        {write ? (
          <Button className="w7 pd sevenly-btn text-white" onClick={handleOpen}>
            Add
          </Button>
        ) : (
          <></>
        )}
      </div>

      <MUIDataTable
        title={"FAQ List"}
        data={allFAQ}
        columns={columns}
        options={options}
      />

      {/* ------------------------------Create FAQ Section ---------------------------------------- */}
      <Dialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        fullWidth={true}
        open={open}
        maxWidth="md"
      >
        <div className="d-flex justify-content-between align-center p-3">
          <h3>
            {" "}
            {type === "edit"
              ? "Edit FAQ Details"
              : type === "view"
              ? "View FAQ"
              : "Create New FAQ"}
          </h3>
          <IconButton onClick={handleClose}>
            <Close />
          </IconButton>
        </div>
        <DialogContent dividers>
          <TextField
            label="FAQ Title"
            variant="outlined"
            required
            fullWidth
            className="my-2"
            placeholder="Enter new faq"
            name="name"
            onChange={handleChange}
            value={name}
            InputProps={{
              readOnly: type === "view", // Makes the field read-only if `type` is "view"
            }}
          />

          <TextField
            label="Category"
            variant="outlined"
            required
            fullWidth
            placeholder="Enter new category"
            className="my-2"
            name="category"
            onChange={handleChange}
            value={category}
            InputProps={{
              readOnly: type === "view", // Makes the field read-only if `type` is "view"
            }}
          />
          <p className="fs-14 fw-500 mb-3">FAQ Answer</p>
          {ReactQuill ? (
            <ReactQuill
              theme="snow"
              value={answer}
              className="my-2"
              onChange={setAnswer}
              style={{ height: "300px" }}
              readOnly={type === "view"}
              modules={{
                toolbar: [
                  [{ header: "1" }, { header: "2" }, { font: [] }],
                  [{ list: "ordered" }, { list: "bullet" }],
                  [{ align: [] }],
                  ["bold", "italic", "underline", "strike"],
                  [{ color: [] }, { background: [] }],
                  [{ script: "sub" }, { script: "super" }],
                  ["link", "image"],
                  ["blockquote", "code-block"],
                  ["clean"],
                ],
              }}
            />
          ) : (
            <div style={{ height: "300px" }} />
          )}
        </DialogContent>
        <DialogActions>
          <Button className="cancel-button" onClick={handleClose}>
            Cancel
          </Button>
          {type !== "view" ? (
            <Button
              className="submit-button"
              variant="contained"
              onClick={handleSubmit}
            >
              {type === "edit" ? "Submit" : "Create"}
            </Button>
          ) : (
            <></>
          )}
        </DialogActions>
      </Dialog>
      {/* ------------------------Delete FAQ---------------------------------- */}
      <Dialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        fullWidth={true}
        open={opendel}
      >
        <div className="d-flex justify-content-between align-center p-3">
          <h3>
            {type === "block" ? (status ? "Unpublish" : "Publish") : "Delete"}
          </h3>
          <IconButton onClick={handleClose}>
            <Close />
          </IconButton>
        </div>
        <DialogContent dividers>
          <p className="fs-14">
            {type === "block"
              ? status
                ? "Are you sure you want to Unpublish the Faq ?"
                : "Are you sure you want to Publish the Faq ?"
              : "Are you sure you want to Delete the Faq ?"}
          </p>
        </DialogContent>
        <DialogActions>
          <Button className="cancel-button" onClick={handleClose}>
            Cancel
          </Button>
          <Button
            className="submit-button"
            variant="contained"
            onClick={handleDelete}
          >
            {type === "block" ? (status ? "Unpublish " : "Publish ") : "Delete"}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
export default FAQManagement;
